import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Environment } from '../../config/environment';
import { Config } from '../../config/config';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConsultaEquifaxService {

  constructor(private http: HttpClient, private Conf: Config) { }

  public consultarEquifax(data: any): Observable<any> {
    let httpOptions = {
      withCredentials: false,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    if (Environment.CREDENTIALS) {
      httpOptions.withCredentials = true;
    }

    let url = this.Conf.ENDPOINT_API + 'consultaEquifax';

    return this.http.post(url, data, httpOptions);
  }

  public getPromotores(): Observable<any> {
    let httpOptions = {
      withCredentials: false,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      observe: 'response' as 'response'
    };

    if (Environment.CREDENTIALS) {
      httpOptions.withCredentials = true;
    }

    let url = this.Conf.ENDPOINT_API + 'getVendorsList';

    return this.http.get(url, httpOptions);
  }
}
